module.exports = __webpack_public_path__ + "static/media/sonicboom_arena@2x.d8217013.png";